import memoizeOne from "memoize-one";
import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
import type { IActiveStatusSubject, IActiveStatus } from "containers/management/management-types";
import _ from "lodash";

export interface IState {
    subject: IActiveStatusSubject;
    isLoading: boolean;
    isPaginationLoading: boolean;
    errors: Error;
}

export const initialState: IState = {
    subject: null,
    isLoading: false,
    isPaginationLoading: false,
    errors: null,
};

export const activeStatusReducer = handleActions<IState, any>(
    {
        [UTILITIES.ACTIVE_STATUSES.CLEAR]: () => {
            return initialState;
        },
        [UTILITIES.ACTIVE_STATUSES.FETCH.START]: (state: IState) => {
            return {
                ...initialState,
                isLoading: true,
                subject: state.subject,
            };
        },
        [UTILITIES.ACTIVE_STATUSES.FETCH.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    errors: payload,
                    isLoading: false,
                };
            }
            return {
                ...state,
                errors: initialState.errors,
                subject: {
                    ...payload,
                    statuses: getActiveStatuses(payload.statuses),
                },
                isLoading: false,
            };
        },
        [UTILITIES.ACTIVE_STATUSES.PAGINATED.START]: (state: IState) => {
            return {
                ...state,
                isPaginationLoading: true,
            };
        },
        [UTILITIES.ACTIVE_STATUSES.PAGINATED.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    errors: payload,
                    isPaginationLoading: false,
                };
            }
            return {
                ...state,
                errors: initialState.errors,
                subject: {
                    ...state.subject,
                    statuses: getActiveStatuses([...state.subject.statuses, ...payload.statuses]),
                },
                isPaginationLoading: false,
            };
        },
    },
    initialState
);

const getActiveStatuses = memoizeOne((statuses: IActiveStatus[]) => {
    return _.uniqBy(statuses, "_id").sort((a, b) => {
        const greatestA = new Date(a.added_on || 0) > new Date(a.removed_on || 0) ? a.added_on : a.removed_on;
        const greatestB = new Date(b.added_on || 0) > new Date(b.removed_on || 0) ? b.added_on : b.removed_on;
        return new Date(greatestB).getTime() - new Date(greatestA).getTime();
    });
});
